import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { forgotPassword } from '../services/authService';
import './Login.css'; // Aynı stil dosyasını kullanıyoruz

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    
    if (!email) {
      setError('Lütfen email adresinizi girin');
      return;
    }

    try {
      setLoading(true);
      
      const response = await forgotPassword(email);
      
      if (response.message) {
        setSuccess(true);
        toast.success('Şifre sıfırlama bağlantısı e-posta adresinize gönderildi');
      }
    } catch (error) {
      console.error('Şifre sıfırlama hatası:', error);
      
      // Google hesapları için özel hata mesajı
      if (error.message?.includes('Google ile oluşturulmuş')) {
        setError('Bu hesap Google ile oluşturulmuş. Lütfen Google ile giriş yapın.');
      } else {
        setError(error.message || 'Şifre sıfırlama işlemi sırasında bir hata oluştu');
      }
      
      toast.error(error.message || 'Şifre sıfırlama işlemi sırasında bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="login-container page-transition">
      <Row className="justify-content-center align-items-center min-vh-100">
        <Col md={6} lg={5}>
          <Card className="shadow-sm login-card">
            <Card.Body className="p-1">
              <div className="text-center mb-4">
                <h2 className="fw-bold">Şifremi Unuttum</h2>
                <p className="text-muted">Şifre sıfırlama bağlantısı için e-posta adresinizi girin</p>
              </div>

              {error && <Alert variant="danger">{error}</Alert>}
              
              {success ? (
                <Alert variant="success">
                  <p className="mb-0">Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.</p>
                  <p className="mb-0">Lütfen gelen kutunuzu kontrol edin. Spam klasörünü de kontrol etmeyi unutmayın.</p>
                </Alert>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email adresinizi girin"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 mb-3"
                    disabled={loading}
                  >
                    {loading ? 'Gönderiliyor...' : 'Şifre Sıfırlama Bağlantısı Gönder'}
                  </Button>

                  <div className="text-center">
                    <p className="mb-0">
                      <Link to="/login" className="text-primary text-decoration-none">
                        Giriş sayfasına dön
                      </Link>
                    </p>
                  </div>
                </Form>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ForgotPassword; 